import { Platform } from 'react-native'

import Button, { ButtonProps } from 'app/components/base/Button'

interface GradientButtonProps extends ButtonProps {}
const GradientButton: RFC<GradientButtonProps> = ({ children, ...props }) => {
  const hoverSx = Platform.select({
    web: {
      '&:hover': {
        boxShadow: '0px 0px 0px 4px rgba(0, 234, 144, 0.12)',
        background:
          'linear-gradient(#fff, #fff) padding-box,linear-gradient(90deg, rgba(23, 211, 255, 1), rgba(0, 234, 144, 1)) border-box',
        border: '1px solid transparent'
      }
    }
  })

  return (
    <Button
      variant="outlined"
      sx={{
        mb: 2,
        py: 2.4,
        px: 7.3,
        ...hoverSx
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default GradientButton
